import React from "react";
import ImageWithFallback from "../Common/ImageWithFallback";
import Currency from "../../packs_helper/scripts/Currency";
import profileButtons from "./_profileButtons";
import AvatarHandler from "../Common/AvatarHandler";
import PopUp from "../Common/PopUp";
import PostData from "../../packs_helper/scripts/PostData";
import TelegramQRImage from "../../assets_v3/images/user-panel/telegram_qr.png"

// const profile_ad = require("../../assets_v3/images/profile-ad.jpg");

const UserPanelMenu = (props) => {
	const TelegramNotificationPopupToggle = () => {
		props.TelegramNotificationPopupToggle();
	};

	const profileButtonsArray = profileButtons(props.user);
	profileButtonsArray.shift();
	return (
		<div className="user-panel-menu">
			<div className="user-panel-menu-top">
				<div className="user-panel-menu-top-user-info">
					<ImageWithFallback src={AvatarHandler(props.user.avatar, props.user.approve_avatar)} width="60" height="60" />
					<strong className="user-panel-menu-top-user-info-username">
						{props.user.short_name}
					</strong>
					<div className="user-panel-menu-top-user-info-balance">
						{props.not_show_identification_number ?
							'##,##' :
							props.user.balance < 0 ?
								Currency(0) :  Currency(props.user.balance)} ₺
					</div>
					<a href="/cikis-yap" data-method="delete" className="user-panel-menu-top-user-info-exit">
						ÇIKIŞ YAP
					</a>
				</div>
				<Button
					ChangeRoute={props.ChangeRoute}
					name="Settings"
					pathname="/profilim"
					active={props.activeSection === "Settings"}
					label="Bilgilerim"
					icon="edit"
					className="btn-darker"
				/>
			</div>

			<button 
				className="btn btn-dark user-panel-menu-button-full"
				onClick={() => TelegramNotificationPopupToggle()}
			>
				<div>
					<svg className="icon">
						<use xlinkHref={"#gs-icon-user-panel-telegram"}></use>
					</svg>
					{props.user.telegram_connection ? 'Telegram Bildirimlerini Kapat' : 'Telegram Bildirimlerini Aç'}
				</div>
			</button>
			{profileButtonsArray.map((button) => (
				<Button
					ChangeRoute={props.ChangeRoute}
					name={button.name}
					pathname={button.pathname}
					active={props.activeSection === button.name}
					alert={button.alert}
					label={button.label}
					icon={button.icon}
					key={button.name}
					className={button.className}
				/>
			))}
			{/* {props.side_image && props.side_image.info && props.side_image.info.img && (
				<a href={props.side_image.image_link} className="user-panel-menu-bottom" target="_blank">
					<img src={`https://img.gamesatis.com/${props.side_image.info.img}.jpg`} alt={props.side_image.text_1} />
				</a>
			)} */}
			{props.telegram_popup && 
				(props.user.telegram_connection ? <TelegramStopPopup
					TelegramNotificationPopupToggle={() => TelegramNotificationPopupToggle()} 
					StopTelegramNotification={() => StopTelegramNotification()}
					isMobile={props.isMobile}
				/> : <TelegramStartPopup
					TelegramNotificationPopupToggle={() => TelegramNotificationPopupToggle()} 
					StopTelegramNotification={() => StopTelegramNotification()}
					isMobile={props.isMobile}
				/>)
			}
		</div>
	);
};

const TelegramStopPopup = (props) => {
	return (<PopUp
		title="Telegram Bildirimlerini Kapat"
		Hide={props.TelegramNotificationPopupToggle}
		className="settings-popup"
	>
		<div className="grid-1">
			<div style={{textAlign:"center"}}>
				Artık telegram üzerinden bildirim <b>almayacaksınız.</b> 
				<br /><br />Bu işleme devam etmek istediğinize emin misiniz?
				</div>
			<div className="grid-2">
				<button
					type="button"
					className="btn btn-default"
					onClick={props.TelegramNotificationPopupToggle}
				>
					Vazgeç
				</button>
				<button
					className="btn btn-red"
					onClick={() => props.StopTelegramNotification()}
				>
					Evet Bildirimleri Kapat
				</button>
			</div>
		</div>
	</PopUp>
	);
}

const TelegramStartPopup = (props) => {
	return (<PopUp
		title="Telegram Bildirimlerini Aç"
		Hide={props.TelegramNotificationPopupToggle}
		className="settings-popup"
	>
		<div className="grid-1">
			<div style={{textAlign:"center"}}>
				{props.isMobile ? <>Bildirim almak için aşağıdaki linke <b>tıklayın.</b></> : <>Bildirim almak için QRCode <b>okutun</b> veya Linke <b>tıklayın.</b></> }
				{!props.isMobile && (
					<>
						<br /><br />
						<img src={TelegramQRImage} />
					</>
				)}
				<br /><br />
				<a href="https://t.me/gamesatis_asistan_bot" style={{textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">
					t.me/gamesatis_asistan_bot
				</a>
			</div>
		</div>
	</PopUp>
	);
}

const StartTelegramNotification = () => {
	PostData('/telegram-baslat').finally(() => {
		props.ChangeRoute(props.activeSection.pathname);
	})
}

const StopTelegramNotification = () => {
	PostData('/telegram-kaldir', { referer: window.location.href })
};

const Button = (props) => {
	const ChangeRoute = () => {
		props.ChangeRoute(props.pathname);
	};
	return (
		<button
			onClick={ChangeRoute}
			className={
				"btn btn-dark user-panel-menu-button" + (props.className ? (" " + props.className) : '') + (props.alert ? " has-alert" : '') + (props.active ? ' active' : '')
			}
		>
			<svg className="icon">
				<use xlinkHref={"#gs-icon-user-panel-" + props.icon}></use>
			</svg>
			{props.label}
		</button>
	);
};
export {UserPanelMenu as default, Button};
